import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function getRelayAgeGroup(swimmerAges) {
  if (!Array.isArray(swimmerAges) || swimmerAges.length === 0) return "Unknown";
  
  const totalAge = swimmerAges.reduce((sum, age) => sum + Number(age), 0);
  
  if (totalAge < 100) return "72-99";
  if (totalAge >= 100 && totalAge <= 119) return "100-119";
  
  const lower = Math.floor(totalAge / 40) * 40;
  const upper = lower + 39;
  return `${lower}-${upper}`;
}
